import type { PixKeyTypeObject, TemplateMessageObject } from '@trendbuild/trend-cloud-api';
import { Base } from './base.model';
import type { RCSData } from './campaign.model';
import { Channel } from './channel.model';
import { Company } from './company.model';
import { MessageTypeEnum } from './enum/message.type.enum';
import { Webhook } from './webhook.model';

export interface WebhookIntegrations extends Base {
  uuid: string;
  name: string;
  url: string;
  actions: Array<WebhookIntegrationsAction>;
  actived: boolean;
  company: Company;
  channel: Channel;
  webhook: Webhook;
  type: WebhookIntegrationsType;
  /** Payee of a PIX payment template send. Only read by Santri integrations (DEV-1992). */
  pix?: WebhookIntegrationsPix;

  // transient
  requestMonth?: number;
  requestTotal?: number;
}

/**
 * Who receives the PIX payment. WhatsApp shows the name and the key to the buyer, so both must be
 * the real payee — the inbound integration payload carries only the code, never these.
 */
export interface WebhookIntegrationsPix {
  merchantName: string;
  key: string;
  keyType: PixKeyTypeObject;
}

/** The five key formats the Central Bank accepts. */
export const WEBHOOK_INTEGRATIONS_PIX_KEY_TYPES: ReadonlyArray<PixKeyTypeObject> = ['CPF', 'CNPJ', 'EMAIL', 'PHONE', 'EVP'];

export type WebhookIntegrationsActionType = 'phone' | 'name' | 'attendance' | 'message' | 'addTag' | 'removeTag' | 'addContactGroup' | 'removeContactGroup' | 'triggerMessage' | 'closeAttendance';
export type WebhookIntegrationsActionTypeMessage = MessageTypeEnum;
export type WebhookIntegrationsType = 'TRENDMULTI' | 'SANTRI';

export interface WebhookIntegrationsAction {
  type: WebhookIntegrationsActionType;
  typeMessage: WebhookIntegrationsActionTypeMessage; // when type === 'message'
  value: string | boolean | number | object | { [key: string]: string };
  template: TemplateMessageObject;
  templateParamsHeader: Array<string>;
  templateParamsBody: Array<string>;
  templateParamsButton: Array<string>;
  previewText: string;
  /**
   * The RCS message of a `message` or `triggerMessage` action on an RCS channel — the campaign's own
   * shape (SPEC-2026-10-rcs-webhook-integration-messages). When present it is authoritative;
   * `typeMessage` / `value` are a plain mirror of it.
   */
  rcsData?: RCSData;
}
